import { Typography } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

interface RedirectWithCountdownProps {
  to: string
  message?: string
  seconds?: number
}

export const RedirectWithCountdown: FC<RedirectWithCountdownProps> = ({
  to,
  message = 'You will be redirected shortly.',
  seconds = 5,
}) => {
  const [countdown, setCountdown] = useState(seconds)
  const navigate = useNavigate()

  useEffect(() => {
    if (countdown === 0) {
      navigate(to)
      return
    }
    const timer = setTimeout(() => setCountdown(countdown - 1), 1000)
    return () => clearTimeout(timer)
  }, [countdown, navigate, to])

  return (
    <Typography variant="h3" align="center" component="p" sx={{ px: 2 }}>
      <Typography>{message}</Typography>
      <Typography sx={{ mt: 4 }}>
        Redirecting in {countdown} seconds.
      </Typography>
    </Typography>
  )
}
